<script setup lang="ts">
import { useToasts } from "@/composables/useToasts";

const { toasts, dismiss } = useToasts();
</script>

<template>
  <div class="stack" role="status" aria-live="polite">
    <TransitionGroup name="toast">
      <button
        v-for="toast in toasts"
        :key="toast.id"
        class="toast"
        :class="toast.kind"
        :title="'Ausblenden'"
        @click="dismiss(toast.id)"
      >
        {{ toast.text }}
      </button>
    </TransitionGroup>
  </div>
</template>

<style scoped>
.stack {
  position: fixed;
  right: 16px;
  bottom: 16px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  z-index: 20;
  max-width: min(420px, calc(100vw - 32px));
}

.toast {
  text-align: left;
  padding: 10px 14px;
  border-radius: var(--radius-sm);
  border: 1px solid var(--line);
  background: var(--panel);
  box-shadow: 0 8px 24px rgb(0 0 0 / 35%);
}

.toast.error {
  border-color: var(--danger);
  background: color-mix(in srgb, var(--danger) 18%, var(--panel));
}

.toast-enter-active,
.toast-leave-active {
  transition: opacity 0.2s, transform 0.2s;
}

.toast-enter-from,
.toast-leave-to {
  opacity: 0;
  transform: translateY(8px);
}
</style>
